import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20collage%20of%20diverse%20fashion%20and%20lifestyle%20products%20in%20scattered%20arrangement%20on%20a%20deep%20charcoal%20gray%20gradient%20backdrop%2C%20products%20include%20sneakers%20handbags%20perfume%20bottles%20and%20accessories%20in%20tiny%20floating%20clusters%2C%20ethereal%20dreamy%20composition%20with%20soft%20glow%20and%20atmospheric%20mist%2C%20artistic%20magazine%20editorial%20style%2C%20dark%20moody%20yet%20elegant%20aesthetic%20with%20warm%20amber%20highlights&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="PandaBuy Spreadsheet product collage background"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-8 border border-background-50/20">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          Updated Weekly &middot; 100+ Active Spreadsheets
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight mb-6">
          Discover the Best
          <br />
          <span className="text-accent-400">PandaBuy Spreadsheet</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-10">
          Access curated product spreadsheets, compare prices instantly, and find the best
          deals across hundreds of categories — all updated weekly. Your shortcut to smarter
          shopping starts here.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Explore Spreadsheets Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/30 text-background-50 text-base font-medium hover:border-background-50/60 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View Trending Deals
          </a>
        </div>

        <div className="mt-20 w-full overflow-hidden">
          <div className="flex gap-4 justify-center flex-wrap">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center gap-2 px-4 py-3 rounded-2xl bg-background-50/15 backdrop-blur-sm border border-background-50/15 hover:border-background-50/40 hover:bg-background-50/25 transition-all duration-300 min-w-[90px] cursor-pointer"
              >
                <div className="w-10 h-10 rounded-xl bg-background-50/20 flex items-center justify-center overflow-hidden group-hover:scale-110 transition-transform duration-300">
                  <img
                    src={cat.thumbUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <span className="text-xs text-background-50/80 group-hover:text-background-50 font-medium whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}